import React, { useEffect, useState } from 'react'
import AllProduct from 'src/components/ProductPage/AllProduct'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

export default function SubCategoryProductSection({
  category,
  subCategory,
  fetchUpdatedProduct,
  page,
  setPage,
  productData,
  childSubCategory = null
}) {
  const router = useRouter()
  const [dataLimite, setDataLimite] = useState(40)
  const [filterData, setFilterData] = useState<any>({ subCategory: [], category: [] })

  // const productByCategory = useSelector((state: any) => state?.productByCategory)
  const sub_category_slug = router?.pathname.split('/')[2]

  // productByCategory?.product?.getAllProducts
  const responseProducts = productData?.product?.getAllProducts;
  return (
    <div className="store-page bg-white">
      <div className="feature-product-align">
        <div className="store-page-cover-info">
          <AllProduct
            products={responseProducts?.data}
            isCalled={productData?.called}
            storeId={0}
            category_slug={category}
            subCategory_slug={subCategory}
            childSubCategory_slug={childSubCategory}
            store_slug={null}
            color={'#FFFFFF'}
            isFilterMenu={true}
            total={responseProducts?.total}
            dataLimite={dataLimite}
            setPage={setPage}
            page={page}
            // topForFilter={34}
            topForFilter={99}
            isMobile={true}
            setFilterData={setFilterData}
            filterData={filterData}
            APIcall={fetchUpdatedProduct}
          />
        </div>
      </div>
    </div>
  )
}
